const TOKEN_KEY = 'myshop-token'

export const isLogin = () => {
  if (localStorage.getItem(TOKEN_KEY)) {
    return true
  }

  return false
}
